<template>
  <div class="picnews">
   <el-carousel height="420px"  :interval="5000">
        <el-carousel-item v-for="(article , index) in articles" :key="index">
            <a :href="`/news/info/${article.plateid}/${article._id}`">
            <img :src="`${global.remoteIp}/uploads/${article.picsrc}`" height="420px" width="1200px"/></a>
        </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  components: {},
  props: {
    plates: Array
  },
  data() {
    return {
      superShow: true,
      articles: [],
      global,
      toparticle:{},
      ttarticles:[],
      Groups: [
        {
          name: "通知公告", 
        }
      ],
    };
  },

  created() {},

  methods: {},

  computed: {},

  mounted() {
    this.$axios
      .get("/api/articles?page=1&limit=10&picnews=1&sort=-createdAt")
      .then((res) => {
        if (res.data) this.articles = this.global.sortByTop(res.data.data);
        
      });
  },

  watch: {},
};
</script>
<style scoped>
.picnews{
  width: 1200px;
height: 420px;
background: #FFFFFF;
margin: auto;
margin-top: 15px;
}
.topcontent{
      background: #F5F5F5;
}
</style>
